export default "__VITE_ASSET__K5EAyAym__"